/**
 * Matrice di doppia materialità — selezione tema, accordion mobile, modale, deep link ?tema=
 *
 * @package HelloElementorChild
 */

var matrixDeepLinkListenersBound = false;
var deepLinkScrolledSlug = '';
var deepLinkScrollTimer = null;

function getRoots(scope) {
  if (!scope) {
    return Array.prototype.slice.call(document.querySelectorAll('[data-camst-matrix]'));
  }

  if (scope.matches && scope.matches('[data-camst-matrix]')) {
    return [scope];
  }

  return Array.prototype.slice.call(scope.querySelectorAll('[data-camst-matrix]'));
}

function prefersReducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function buildTopicUrl(topicId) {
  var url = new URL(window.location.href);

  if (topicId) {
    url.searchParams.set('tema', topicId);
  } else {
    url.searchParams.delete('tema');
  }

  return url.toString();
}

function syncTopicUrl(topicId) {
  if (!topicId || !window.history || typeof window.history.replaceState !== 'function') {
    return;
  }

  var nextUrl = buildTopicUrl(topicId);

  if (nextUrl === window.location.href) {
    return;
  }

  window.history.replaceState({ camstMatrixTopic: topicId }, '', nextUrl);
}

function selectTopic(root, topicId) {
  if (!topicId) {
    return;
  }

  var rows = root.querySelectorAll('.camst-matrix__row');
  Array.prototype.forEach.call(rows, function (row) {
    var trigger = row.querySelector('[data-camst-matrix-trigger]');
    var rowTopic = trigger ? trigger.getAttribute('data-topic-id') : null;
    row.classList.toggle('is-selected', rowTopic === topicId);
  });

  var panels = root.querySelectorAll('[data-camst-matrix-panel]');
  Array.prototype.forEach.call(panels, function (panel) {
    var isActive = panel.getAttribute('data-topic-id') === topicId;
    panel.classList.toggle('is-active', isActive);

    if (isActive) {
      panel.removeAttribute('hidden');
    } else {
      panel.setAttribute('hidden', '');
    }
  });

  syncTopicUrl(topicId);
}

function openTopicAccordion(root, accordion) {
  var trigger = accordion.querySelector('[data-camst-matrix-accordion-trigger]');
  var panel = accordion.querySelector('[data-camst-matrix-accordion-panel]');

  if (!trigger || !panel) {
    return;
  }

  var accordions = root.querySelectorAll('[data-camst-matrix-accordion]');
  Array.prototype.forEach.call(accordions, function (item) {
    if (item === accordion) {
      return;
    }

    item.classList.remove('is-open');
    var itemTrigger = item.querySelector('[data-camst-matrix-accordion-trigger]');
    var itemPanel = item.querySelector('[data-camst-matrix-accordion-panel]');

    if (itemTrigger) {
      itemTrigger.setAttribute('aria-expanded', 'false');
    }

    if (itemPanel) {
      itemPanel.setAttribute('hidden', '');
    }
  });

  accordion.classList.add('is-open');
  trigger.setAttribute('aria-expanded', 'true');
  panel.removeAttribute('hidden');

  var topicId = accordion.getAttribute('data-topic-id');

  if (topicId) {
    selectTopic(root, topicId);
  }
}

function toggleAccordion(root, accordion) {
  var trigger = accordion.querySelector('[data-camst-matrix-accordion-trigger]');
  var panel = accordion.querySelector('[data-camst-matrix-accordion-panel]');

  if (!trigger || !panel) {
    return;
  }

  var willOpen = !accordion.classList.contains('is-open');

  if (willOpen) {
    openTopicAccordion(root, accordion);
    return;
  }

  accordion.classList.remove('is-open');
  trigger.setAttribute('aria-expanded', 'false');
  panel.setAttribute('hidden', '');
}

function pulseSelectedRow(root) {
  var selected = root.querySelector('.camst-matrix__row.is-selected');

  if (!selected) {
    return;
  }

  selected.classList.add('is-deep-linked');
  window.setTimeout(function () {
    selected.classList.remove('is-deep-linked');
  }, 1400);
}

function getDeepLinkSlug(root) {
  var params = new URLSearchParams(window.location.search);
  var fromUrl = params.get('tema') || '';

  if (fromUrl) {
    return fromUrl;
  }

  return root.getAttribute('data-camst-matrix-deep-link') || '';
}

function topicExists(root, topicId) {
  if (!topicId) {
    return false;
  }

  return root.querySelector('[data-camst-matrix-trigger][data-topic-id="' + topicId + '"]') !== null;
}

function isMatrixDesktop() {
  return window.matchMedia('(min-width: 1024px)').matches;
}

function getHeaderOffset() {
  var header = document.querySelector('[data-camst-header]');

  if (!header) {
    return 0;
  }

  return Math.ceil(header.getBoundingClientRect().height || header.offsetHeight || 0);
}

function getDeepLinkScrollTarget(root, topicId) {
  if (isMatrixDesktop()) {
    return (
      root.querySelector('[data-camst-matrix-panel][data-topic-id="' + topicId + '"]') ||
      root.querySelector('.camst-matrix__detail-col')
    );
  }

  return (
    root.querySelector('[data-camst-matrix-accordion][data-topic-id="' + topicId + '"]') ||
    root.querySelector('.camst-matrix__accordions')
  );
}

function scrollToElement(element) {
  if (!element) {
    return;
  }

  var offset = getHeaderOffset() + 16;
  var top = element.getBoundingClientRect().top + window.pageYOffset - offset;

  window.scrollTo({
    top: Math.max(0, top),
    behavior: prefersReducedMotion() ? 'auto' : 'smooth',
  });
}

function getDeepLinkRoots(scope) {
  return getRoots(scope).filter(function (root) {
    var slug = getDeepLinkSlug(root);
    return slug !== '' && topicExists(root, slug);
  });
}

function prepareDeepLinkSelection(root) {
  var topicId = getDeepLinkSlug(root);

  if (!topicId || !topicExists(root, topicId)) {
    return false;
  }

  selectTopic(root, topicId);

  var accordion = root.querySelector('[data-camst-matrix-accordion][data-topic-id="' + topicId + '"]');

  if (accordion) {
    openTopicAccordion(root, accordion);
  }

  return true;
}

function runDeepLinkScrollOnce(scope) {
  var roots = getDeepLinkRoots(scope);

  if (!roots.length) {
    return;
  }

  var topicId = getDeepLinkSlug(roots[0]);

  if (!topicId || deepLinkScrolledSlug === topicId) {
    return;
  }

  roots.forEach(prepareDeepLinkSelection);

  var target = getDeepLinkScrollTarget(roots[0], topicId);

  if (!target) {
    return;
  }

  deepLinkScrolledSlug = topicId;
  scrollToElement(target);
  roots.forEach(pulseSelectedRow);
}

function queueDeepLinkScroll(scope) {
  var roots = getDeepLinkRoots(scope);

  if (!roots.length) {
    return;
  }

  roots.forEach(prepareDeepLinkSelection);

  if (deepLinkScrolledSlug === getDeepLinkSlug(roots[0])) {
    return;
  }

  if (deepLinkScrollTimer) {
    window.clearTimeout(deepLinkScrollTimer);
  }

  deepLinkScrollTimer = window.setTimeout(function () {
    deepLinkScrollTimer = null;

    window.requestAnimationFrame(function () {
      window.requestAnimationFrame(function () {
        runDeepLinkScrollOnce(scope);
      });
    });
  }, 380);
}

function ensureDeepLinkScheduling(scope) {
  var roots = getDeepLinkRoots(scope);

  if (!roots.length) {
    return;
  }

  roots.forEach(prepareDeepLinkSelection);
  queueDeepLinkScroll(scope);

  if (matrixDeepLinkListenersBound) {
    return;
  }

  matrixDeepLinkListenersBound = true;

  window.addEventListener(
    'load',
    function () {
      queueDeepLinkScroll(document);
    },
    { once: true }
  );

  document.addEventListener('camst:preloader:complete', function () {
    queueDeepLinkScroll(document);
  });
}

function openModal(root) {
  var modal = root.querySelector('[data-camst-matrix-modal]');

  if (!modal) {
    return;
  }

  modal.removeAttribute('hidden');
  modal.classList.add('is-open');
  document.body.classList.add('camst-matrix-modal-open');
}

function closeModal(root) {
  var modal = root.querySelector('[data-camst-matrix-modal]');

  if (!modal) {
    return;
  }

  modal.classList.remove('is-open');
  modal.setAttribute('hidden', '');
  document.body.classList.remove('camst-matrix-modal-open');
}

function bindRoot(root) {
  if (root.dataset.camstMatrixInit === '1') {
    return;
  }

  root.dataset.camstMatrixInit = '1';

  var triggers = root.querySelectorAll('[data-camst-matrix-trigger]');
  Array.prototype.forEach.call(triggers, function (trigger) {
    trigger.addEventListener('click', function () {
      selectTopic(root, trigger.getAttribute('data-topic-id'));
    });
  });

  var accordionTriggers = root.querySelectorAll('[data-camst-matrix-accordion-trigger]');
  Array.prototype.forEach.call(accordionTriggers, function (trigger) {
    trigger.addEventListener('click', function () {
      var accordion = trigger.closest('[data-camst-matrix-accordion]');

      if (accordion) {
        toggleAccordion(root, accordion);
      }
    });
  });

  var openButtons = root.querySelectorAll('[data-camst-matrix-open]');
  Array.prototype.forEach.call(openButtons, function (button) {
    button.addEventListener('click', function () {
      openModal(root);
    });
  });

  var closeButtons = root.querySelectorAll('[data-camst-matrix-close]');
  Array.prototype.forEach.call(closeButtons, function (button) {
    button.addEventListener('click', function () {
      closeModal(root);
    });
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') {
      closeModal(root);
    }
  });
}

export function initCamstMaterialityMatrix(scope) {
  getRoots(scope).forEach(bindRoot);
  ensureDeepLinkScheduling(scope);
}

export function refreshCamstMaterialityMatrixDeepLink(scope) {
  getDeepLinkRoots(scope).forEach(prepareDeepLinkSelection);
}

export function teardownCamstMaterialityMatrix(scope) {
  getRoots(scope).forEach(function (root) {
    delete root.dataset.camstMatrixInit;
    closeModal(root);
  });
}
